import * as actions_assets from 'actions/assets-actions';
import * as toolbox from 'components/common/toolbox';
import React, { useEffect, useState } from 'react';
import { useHistory, useLocation } from 'react-router-dom';
import { elasticSearch, Ibox, Table } from 'enspire-manager-framework';
import { useDispatch, useSelector } from 'react-redux';
import { useParams } from 'react-router-dom';
import _ from 'lodash';

const isDev = (process.env.REACT_APP_FIREBASE_ENV == 'development');

export default function StockPartsSearch(props) {

	/* Hooks --------------------------*/

	const params = useParams();
	const history = useHistory();
	const dispatch = useDispatch();
	const routeLocation = useLocation();
	const assets = useSelector((store) => store.assets);
	const asset = assets.assets?.find((asset) => asset.id == params.asset_id);
	const assetTypes = useSelector((store) => store.settings.settings_asset_types);
	const partsCategories = useSelector((store) => store.settings.settings_parts_categories)?.filter(
		(o) => o.assetType == assetTypes.find((assetType) => assetType.id == params.asset_type_id)?.id);
	const stockParts = useSelector((store) => store.stockParts);
	const stockPartsIndex = useSelector((store) => store.settings.settings?.values?.stockPartsIndex);
	const [filter, setFilter] = useState('');
	const [state, setState] = useState({
		loading: false,	
		search: '',
		hits: [],
		timeout: null,
	});

	/* Effects --------------------------*/

	useEffect(() => {
		dispatch(actions_assets.selectAssetType(params.asset_type_id));
		updateSearch(state.search);
	}, [params.asset_type_id]);

	useEffect(() => {
		setTimeout(() => {
			updateSearch(state.search);
		}, 1000);
	}, [stockPartsIndex, stockParts.stock_part_save_pending]);

	useEffect(() => {
		updateSearch(state.search);
	}, [filter]);

	/* Handlers --------------------------*/

	const handleFilter = (filter) => {
		setFilter(filter);
	};
	const updateSearch = async (search) => {
		setState((prevState) => ({ ...prevState, loading: true }));

		const indexHandle = 'maint-' + params.handle + ((isDev) ? '-dev' : '');
		var config = {
			table: indexHandle + '-stock-parts',
			fields: ['name', 'partNumber', 'manufacturer', 'description'],
			filter: [
				{ field: 'assetTypeId', value: params.asset_type_id },
				{ field: 'categoryIds', value: filter }
			],
			sort: [{ "name": "asc" }],
		};
		var hits = await elasticSearch(search, config);
		if (!props.primary) hits = _.filter(hits, (hit) => !asset.parts?.includes(hit.id));

		setState((prevState) => ({ ...prevState, hits, search, loading: false }));

		return false; // prevent <Enter> key from reloading
	};
    const handleAdd = (searchItem, event) => {
        if (event?.stopPropagation) event?.stopPropagation();
		dispatch(actions_assets.saveStockPartToAsset(params.handle, params.asset_id, searchItem.id, false));
	};

	/* Constants --------------------------*/

	var columns; 

	if (props.primary) {
		columns = [
			{ name: "Name", field: "name", width: 15 },
			{ name: "Part #", field: "partNumber", width: 15 },
			{ name: "Manufacturer", field: "manufacturer", width: 15 },
			{ name: "Description", field: "description", width: 55 },
		];
	} else {
		columns = [
			{ name: "Name", field: "name", width: 35 },
			{ name: "Part #", field: "partNumber", width: 20 },
			{ name: "Manufacturer", field: "manufacturer", width: 35 },
			{ name: 'Add', field: 'id', type: 'button', button: { name: <i className="fas fa-plus"></i>, className: 'btn-primary btn-xs', callback: handleAdd }, width: 10 }
		];
	}

	return (

		<Table
			active_field={'id'}
			active_id={params.stock_part_id}
			data={state.hits}
			show_limit={false}
			show_search={true}
			highlight_search={true}
			search_query={state.search}
			search_callback={updateSearch}
			columns={columns}
			click_callback={ (props.primary) ? (stockPart) => {
				toolbox.listLink(history, routeLocation?.pathname, 4, stockPart.id + "/form/0", "assets", 7)
			} : null }
			button={ (props.primary) ? "+ New Stock Part" : ''}
			button_in_ibox={true}
			button_callback={() => {
				let location = toolbox.modifyPath(routeLocation?.pathname, 5, "stock-part-form/0"); // 4th segment if no id existing
				history.push({ pathname: location });
			}}
			filters={{
				name: 'Parts Category',
				field: 'categoryId',
				buttons: partsCategories?.map((category) => ({ name: toolbox.toProperCase(category.name), value: category.id })) ?? [],
				limit: 6,
				filter_callback: handleFilter
			}}
			container_id={ (props.primary) ? 'column1' : null }
			container_margin={ (props.primary) ? 320 : null }
		/>
	);
}
